const EacLogo: React.FC = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="28"
      viewBox="0 0 28 28"
    >
      <g id="Layer_2" data-name="Layer 2" transform="translate(0)">
        <g id="Layer_1" data-name="Layer 1" transform="translate(0)">
          <path
            id="Path_1"
            data-name="Path 1"
            d="M12.91,25.7H23.9L12.91,14.66Z"
            transform="translate(2.084 2.296)"
            fill="#004d71"
          />
          <path
            id="Path_2"
            data-name="Path 2"
            d="M12.91,13.239l13.006,13.04V5.57Z"
            transform="translate(2.084 1.194)"
            fill="#00a0df"
          />
          <g id="Group_1" data-name="Group 1">
            <path
              id="Path_3"
              data-name="Path 3"
              d="M26.24,5.445V.915A.915.915,0,0,0,25.325,0H.915A.915.915,0,0,0,0,.915v24.41a.915.915,0,0,0,.915.915H12.983V13.383Z"
              transform="translate(0)"
              fill="#4f4e51"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export default EacLogo;
